import screen from './Main';

export default screen;



// WEBPACK FOOTER //
// ./src/screens/admin/Products/Edit/index.js